import { handleResponseErr } from '../../utils/handleResponseErr'
import iziToast from 'izitoast'
import 'izitoast/dist/css/iziToast.min.css'

const DEFAULT_STATE = {
  roles: null,
  role: null,
  actions:{
    get_roles: {
      loading: false,
      errMsg: null,
    },
  }
}

export default function roles (state = DEFAULT_STATE, action) {
  switch (action.type){

      case "GET_ROLES_PENDING":
        return {
          ...DEFAULT_STATE,
          actions:{
            ...state.actions,
            get_roles:{ loading: true }
          }
        }

      // on success
      case "GET_ROLES_FULFILLED":
        return {
          ...state,
          roles: action.payload.data.data.roles,
          actions:{
            ...state.actions,
            get_roles: DEFAULT_STATE.actions.get_roles
          }
        }

      // on rejected
      case "GET_ROLES_REJECTED":
        return {
          ...state,
          actions:{
            ...state.actions,
            get_roles:{
              loading: false,
              errMsg:  handleResponseErr(action.payload)
            }
          }
        }


      default: return state
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/roles.js